module.exports = __webpack_public_path__ + "static/fun-time/audio/story5//20.1.mp3";